<template>
  <Button class="ai-chat-button"
          :class="[elementAiButtonPosition, elementAiButtonSize]"
          v-tooltip="{ value: elementData.aiButtonTooltip ?? 'Ask AI', showDelay: 600, hideDelay: 100 }"
          @click="openSidebar(elementData.id)"
  >
    <template v-if="elementAiButtonIcon" #icon>
      <i :class="elementAiButtonIcon"></i>
    </template>
    <template v-else #icon>
      <img :src="gemini" alt="AI Icon" class="button-icon" />
    </template>
  </Button>
  <SidePanel v-if="activePanelId === elementData.id" v-model:visible="isSidebarVisible" :id="elementData.id" :elementData="elementData" />
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import SidePanel from "@/views/AiChat/side-panel.vue";
import gemini from '@/assets/images/gemini-logo.png'
import {storeToRefs} from "pinia";
import {useSlidesStore} from "@/store";
const { theme } = storeToRefs(useSlidesStore())

const props = defineProps({
  elementData: {
    type: Object,
    required: true,
  }
})
const isSidebarVisible = ref(false);
const elementAiButtonIcon = computed(() => theme.value.aiButton.icon)
const elementAiButtonBg = computed(() => theme.value.aiButton.backgroundColor)
const elementAiButtonColor = computed(() => theme.value.aiButton.color)
const elementAiButtonOutline = computed(() => theme.value.aiButton.outlineColor)
const elementAiButtonOpacity = computed(() => theme.value.aiButton.opacity)
const elementAiButtonSize = computed(() => theme.value.aiButton.size ?? 'Medium')
const elementAiButtonPosition = computed(() => theme.value.aiButton.position ?? 'top-right')

const activePanelId = ref('')
const openSidebar = (id: string) => {
  activePanelId.value = id
  isSidebarVisible.value = true
}

</script>

<style lang="scss" scoped>
.ai-chat-button {
  position: absolute;
  z-index: 10;
  background-color: v-bind(elementAiButtonBg);
  color: v-bind(elementAiButtonColor);
  border: 1px solid v-bind(elementAiButtonOutline);
  border-radius: 99px;
  opacity: v-bind(elementAiButtonOpacity);

  &.Small {
    width: 30px;
    padding: 6px;

    &:deep(.p-button-icon) {
      font-size: .8rem;
    }
    &:deep(.button-icon) {
      width: 15px;
      height: 15px;
    }
  }

  &.Medium {
    padding: 10px;

    &:deep(.p-button-icon) {
      font-size: 1.1rem;
    }
    &:deep(.button-icon) {
      width: 18px;
      height: 18px;
    }
  }

  &.Large {
    width: 50px;
    padding: 14px;

    &:deep(.p-button-icon) {
      font-size: 1.4rem;
    }
    &:deep(.button-icon) {
      width: 22px;
      height: 22px;
    }
  }

  &.top-left {
    top: 5px;
    left: 5px;
  }

  &.bottom-left {
    bottom: 5px;
    left: 5px;
  }

  &.top-right {
    top: 5px;
    right: 5px;
  }

  &.bottom-right {
    bottom: 5px;
    right: 5px;
  }

  &:hover {
    filter: brightness(1.1);
  }
}
</style>